export default "__VITE_ASSET__CYhPzyKo__"